<template>
    <div class="sidebar sidebar-light sidebar-main sidebar-expand-md align-self-md-start">
        <div class="sidebar-mobile-toggler text-center">
            <a href="#" class="sidebar-mobile-main-toggle">
                <i class="icon-arrow-left8"></i>
            </a>
            <span class="font-weight-semibold">{{ title }}</span>
            <a href="#" class="sidebar-mobile-expand">
                <i class="icon-screen-full"></i>
                <i class="icon-screen-normal"></i>
            </a>
        </div>
        <div class="sidebar-content">
            <div class="card card-sidebar-mobile">
                <div class="card-header bg-light header-elements-inline">
                    <h6 class="card-title">{{ title }}</h6>
                    <div class="header-elements">
                        <div class="list-icons">
                            <a class="list-icons-item" data-action="collapse"></a>
                        </div>
                    </div>
                </div>
                <div class="card-body p-0">
                    <ul class="nav nav-sidebar" data-nav-type="accordion">
                        <slot></slot>
                    </ul>
                </div>
            </div>
        </div>
    </div>

    <Teleport to="#mobile-navbar">
        <button class="navbar-toggler sidebar-mobile-main-toggle" type="button">
            <i class="icon-paragraph-justify3"></i>
        </button>
    </Teleport>
</template>
<script>
export default {
    name: "IntegrationSidebarComponent",
    props: {
        title: {
            type: String,
            required: true
        }
    },
}
</script>